import React from 'react';

export function ProjectTasksCalendar() {
  const days = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
  // Giả lập dữ liệu tháng 5, 2024
  const dates = [
    29, 30, 1, 2, 3, 4, 5,
    6, 7, 8, 9, 10, 11, 12,
    13, 14, 15, 16, 17, 18, 19,
    20, 21, 22, 23, 24, 25, 26,
    27, 28, 29, 30, 31, 1, 2
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Lịch làm việc</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Chi tiết</button>
      </div>

      <div className="grid grid-cols-7 gap-1 text-center">
        {days.map(day => (
          <span key={day} className="text-xs font-normal text-slate-400 py-1">{day}</span>
        ))}
        {dates.map((date, idx) => {
          const isCurrentMonth = idx >= 2 && idx <= 32;
          const isToday = date === 15 && isCurrentMonth;
          return (
            <div 
              key={idx} 
              className={`
                aspect-square flex items-center justify-center text-xs font-normal rounded-md cursor-pointer transition-all
                ${isToday ? 'bg-emerald-600 text-white font-normal shadow-sm' : 'hover:bg-slate-50 text-slate-700'}
                ${!isCurrentMonth ? 'opacity-30' : ''}
              `}
            >
              {date}
            </div>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-x-4 gap-y-2 pt-2 border-t border-slate-50">
        <LegendItem color="bg-emerald-500" label="Hoàn thành" />
        <LegendItem color="bg-blue-500" label="Đang thực hiện" />
        <LegendItem color="bg-rose-500" label="Quá hạn" />
        <LegendItem color="bg-slate-300" label="Chưa bắt đầu" />
      </div>
    </div>
  );
}

function LegendItem({ color, label }: { color: string; label: string }) {
  return (
    <div className="flex items-center gap-1.5">
      <div className={`w-1.5 h-1.5 rounded-full ${color}`} />
      <span className="text-xs font-normal text-slate-400">{label}</span>
    </div>
  );
}
